'use client'
import React from 'react'
import { ApolloProvider } from '@apollo/client/react'
import { useRouter } from 'next/navigation'
import { SnackbarProvider } from 'notistack'

import { apolloClient } from '@docpace/apps/reception-status-app/client'
import { useIsChangingRoute } from '@docpace/shared-react-hooks/useIsChangingRoute'
import { useSessionSharing } from '@docpace/shared-react-hooks/useSessionSharing'
import receptionStatusRoutes from '@docpace/shared-react-routes/receptionStatusRoutes'

export default function ReceptionStatusLayoutClientComponent({
    // Layouts must accept a children prop.
    // This will be populated with nested layouts or pages
    children,
}: {
    children: React.ReactNode
}) {
    useIsChangingRoute()
    const router = useRouter()
    const { isInitialized } = useSessionSharing({
        // another tab signed out — drop cached data and leave authed pages
        onSessionCleared: async () => {
            try {
                await apolloClient.clearStore()
            } catch (e) {}
            router.replace(receptionStatusRoutes.Signin.hrefNext())
        },
    })

    return (
        <ApolloProvider client={apolloClient}>
            <SnackbarProvider
                maxSnack={3}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                {isInitialized && children}
            </SnackbarProvider>
        </ApolloProvider>
    )
}
